import React from "react";

import { testLocator } from "@/lib/helpers/test-locator";

const TextArea = (props) => {
  const { cols, name, onChange, rows, textareaProps, value } = props;

  return (
    <span className={"TextArea " + props.spanClasses}>
      <textarea
        className={"TextArea__input " + props.classes}
        cols={cols || 50}
        disabled={props.disabled}
        {...testLocator(props.testId)}
        id={props.ids}
        name={name}
        onChange={onChange}
        placeholder={props.placeholder || ""}
        rows={rows || 3}
        value={value}
        {...textareaProps}
      />
    </span>
  );
};

export default TextArea;
